//:: AUTH
export const AUTH_REGISTER_REQUEST = "AUTH_REGISTER_REQUEST";
export const AUTH_RESEND_CONFIMATION = "AUTH_RESEND_CONFIMATION";
export const AUTH_CONFIRMATION = "AUTH_CONFIRMATION";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_CHECK_LOGIN = "AUTH_CHECK_LOGIN";
export const AUTH_SET_NEW_PASSWORD = "AUTH_SET_NEW_PASSWORD";
export const AUTH_PASSWORD_RESET_REQUEST = "AUTH_PASSWORD_RESET_REQUEST";
export const AUTH_PASSWORD_RESET_COMPLETE = "AUTH_PASSWORD_RESET_COMPLETE";
export const AUTH_INVITE = "AUTH_INVITE";
export const AUTH_STAFF = "AUTH_STAFF";
export const AUTH_CREATE_GUEST = "AUTH_CREATE_GUEST";
export const AUTH_VERIFY = "AUTH_VERIFY";

//:: MODELS & COLLECTIONS
export const PROJECT__FETCH_CURRENT = "PROJECT__FETCH_CURRENT";
export const PROJECT__SET_CURRENT = "PROJECT__SET_CURRENT";
export const SUBMISSION__SET_CURRENT = "SUBMISSION__SET_CURRENT";
export const SUBMISSION__FETCH_CURRENT = "SUBMISSION__FETCH_CURRENT";
export const SAMPLE__SET_CURRENT = "SAMPLE__SET_CURRENT";
export const SAMPLE__FETCH_CURRENT = "SAMPLE__FETCH_CURRENT";

//:: Lab Context
export const LAB_CONTEXT_SET = "LAB_CONTEXT_SET";
export const LAB_CONTEXT_INIT = "LAB_CONTEXT_INIT";

//:: Breadcrumbs
export const BREADCRUMB_NAME = "BREADCRUMB_NAME";

//:: Overlay
export const OVERLAY_SHOW = "OVERLAY_SHOW";
export const OVERLAY_HIDE = "OVERLAY_HIDE";

//:: Trash
export const PUT_TO_TRASH = "PUT_TO_TRASH";
export const RESTORE_FROM_TRASH = "RESTORE_FROM_TRASH";
export const CLEAR_TRASH = "CLEAR_TRASH";

//:: Project form
export const UPDATE_STEP_ONE = "UPDATE_STEP_ONE";
export const ADD_NEW_SUBMISSION = "ADD_NEW_SUBMISSION";
export const UPDATE_SUBMISSION = "UPDATE_SUBMISSION";
export const DELETE_SUBMISSION = "DELETE_SUBMISSION";
export const SET_SAMPLE_TYPE = "SET_SAMPLE_TYPE";
export const SET_TEST_PACKAGE_GROUPS = "SET_TEST_PACKAGE_GROUPS";
export const SET_SERVICE_QUESTIONS = "SET_SERVICE_QUESTIONS";
export const SET_TURNAROUNDS = "SET_TURNAROUNDS";
export const UPDATE_FORM_STATUS = "UPDATE_FORM_STATUS";
export const UPDATE_SUBMISSION_SAMPLE = "UPDATE_SUBMISSION_SAMPLE";
export const RESET_STORE = "RESET_STORE";

//:: Attribute form
export const UPDATE_PARENT_ID = "UPDATE_PARENT_ID";

//;; Receive store
export const RECEIVE_ADD = "RECEIVE_ADD";
export const RECEIVE_REMOVE = "RECEIVE_REMOVE";
export const RECEIVE_REMOVE_ALL = "RECEIVE_REMOVE_ALL";

//:: Schedule store
export const SET_SELECTED_DATE = "SET_SELECTED_DATE";
export const RESET_SCHEDULE_FORM = "RESET_SCHEDULE_FORM";
export const UPDATE_SCHEDULE_FORM = "UPDATE_SCHEDULE_FORM";
export const UPDATE_SCHEDULE_SAMPLE_LIST = "UPDATE_SCHEDULE_SAMPLE_LIST";
